import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { exists } from '@utils/functions.js'

export const initialState = {}

export const embedKey = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_EMBED_KEYS, (state, action) => receiveEmbedKeys(state, action))
})

export default embedKey

function receiveEmbedKeys(state, action) {
  const { payload: embedKeys } = action
  // Note: Embed keys map is keyed by timeline id
  if (exists(embedKeys)) {
    state = {
      ...state,
      ...embedKeys,
    }
  }
  return state
}
